

















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import LoadingDialog from '@/components/Views/UI/LoadingDialog.vue';
import {FeathersVuexFindAll} from '@/utils';
import {nil} from '@/common';

@Component({
    components: {LoadingDialog},
})
export default class PagedTable extends Vue {
    [x: string]: any;

    @Prop({default: true})
    public showControls!: boolean;

    @Prop({default: true})
    public showActions!: boolean;

    get hasActions(): boolean {
        return this.showActions && (this.hasEdit || this.hasDelete || this.hasView);
    }

    get headersWithActions(): any[] {
        return this.hasActions ? [...this.headers, {
            text: 'Actions',
            align: 'center',
            sortable: false,
        }] : this.headers;
    }

    get selectedItems(): any[] {
        return this.items.filter((x) => x.selected);
    }

    get itemsPerPage(): number {
        return this.pagination.rowsPerPage || this.rowsPerPage[0];
    }

    get page(): number {
        return this.pagination.page || 1;
    }

    get sortBy(): string {
        return this.pagination.sortBy || '_id';
    }

    get sortDirection(): number {
        return this.pagination.descending ? -1 : 1;
    }

    get onlyToolbarUI() {
        return !this.hasTitle && !this.hasCreate && !this.hasImport && !this.hasExport;
    }

    @Prop({default: () => []})
    public headers!: any[];

    @Prop({default: () => undefined})
    public feathersModel!: any;

    @Prop({default: ''})
    public title!: string;

    @Prop({default: true})
    public selectable!: boolean;

    @Prop({default: '_id'})
    public itemKey!: string;

    @Prop({default: () => [5, 10, 25, 50, 100]})
    public rowsPerPage!: number[];

    @Prop({default: () => (() => undefined)})
    public onQuery!: (() => any);

    @Prop({default: false})
    public flat!: boolean;

    @Prop({default: false})
    public renderInSlot!: boolean;

    @Prop({default: '_id'})
    public defaultSortBy!: string;

    @Prop({default: false})
    public defaultDescending!: boolean;

    /*pagination = Object.defineProperties({},{
        descending:{value:false, writable:true},
        sortBy:{value:"category", writable:true},
        page: {value:0, writable:true },
        rowsPerPage:{value:5, writable:true},
        totalItems: {value:0, writable:true},
    });*/
    public pagination = Object.assign({}, {
        descending: this.defaultDescending,
        sortBy: this.defaultSortBy,
        page: 1,
        rowsPerPage: 5,
    });

    private selectAllMessage = false;
    private bulkSelection: any[] | null = null;
    private doNotClearSelection: boolean = false;
    private loading = true;
    private selected: any[] = [];
    private items: any[] = [];
    private hasEdit = false;
    private hasView = false;
    private hasDelete = false;
    private hasCreate = false;
    private hasImport = false;
    private hasExport = false;
    private hasTitle = false;
    private totalItems = 0;

    @Watch('selected')
    public onSelectedChanged(value: any[], oldValue: any[]) {
        if (!nil(this.bulkSelection)) {
            if (this.doNotClearSelection) {
                this.selected = this.bulkSelection;
            } else {
                this.bulkSelection = null;
            }
        } else {
            this.selectAllMessage = value.length > 0 && value.length !== this.totalItems;
        }
        this.$emit('input', value);
    }

    @Watch('pagination')
    public onPaginationChanged(value: any, oldValue: any) {
        this.refresh();
    }

    public created() {

        if (!nil(this._events.onEdit)) {
            this.hasEdit = true;
        }
        if (!nil(this._events.onView)) {
            this.hasView = true;
        }
        if (!nil(this._events.onDelete)) {
            this.hasDelete = true;
        }
        if (!nil(this._events.onCreate)) {
            this.hasCreate = true;
        }
        if (!nil(this._events.onImport)) {
            this.hasImport = true;
        }
        if (!nil(this._events.onExport)) {
            this.hasExport = true;
        }
        if (!nil(this.title, true)) {
            this.hasTitle = true;
        }

        this.initialize();
    }

    public editItem(item: any) {
        this.$emit('onEdit', item);
    }

    public deleteItem(item: any) {
        this.$emit('onDelete', item);
    }

    public viewItem(item: any) {
        this.$emit('onView', item);
    }

    public onPaged() {
        if (!nil(this.bulkSelection)) {
            this.doNotClearSelection = true;
        }
    }

    public async selectAll() {
        (this.$refs.loadingDialog as any).open = true;
        const sortObj: any = {};
        sortObj[this.sortBy] = this.sortDirection;
        this.bulkSelection = await FeathersVuexFindAll(this.feathersModel, {
            query: {
                $sort: sortObj,
                ...this.onQuery(),
            },
        });
        this.selected = this.bulkSelection;
        (this.$refs.loadingDialog as any).open = false;
    }

    public async refresh(resetState = false) {
        if (nil(this.feathersModel)) {
            return;
        }
        if (resetState) {
            this.doNotClearSelection = false;
            this.bulkSelection = null;
            this.selected = [];
        }
        this.loading = true;
        const sortObj: any = {};
        sortObj[this.sortBy] = this.sortDirection;

        const response = await this.feathersModel.find({
            query: {
                $limit: this.itemsPerPage,
                $skip: (this.page - 1) * this.itemsPerPage,
                $sort: sortObj,
                ...this.onQuery(),
            },
        });
        this.loading = false;
        this.items = response.data;
        this.totalItems = response.total;
    }

    public selectionLogic(props) {
        if (this.doNotClearSelection) {
            this.doNotClearSelection = false;
            this.bulkSelection = null;
            this.selected = [];
        } else {
            props.selected = !props.selected;
        }
    }

    public async initialize() {
        this.refresh();
    }
}
